import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GroupType, ModuleGroup } from "@maysoft/common-component-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Helpers from "commons/helpers";
import Constants from "constants/index";
import Screens from "constants/screens";
import Strings from "constants/strings";

import { RootState } from "store";
import { BooleanInt, Mode } from "constants/enum";
import { DashboardLayout } from "layout";
import { setListPathName } from "store/slice/titleRoute.slice";


interface IRequestGetPaged {
    orderby?: string;
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;
    searchText?: string;
    listStatus?: string[];
    includeCompany?: number;
}

const DepartmentScreen = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const idDetail = searchParams.get("id");
    const modeList = (Screens.DEPARTMENT_LIST.includes(window.location.pathname));
    const pramsMode = !Helpers.isNullOrEmpty(searchParams.get("mode")) ? Number(searchParams.get("mode")) : undefined;

    const listPathName = useSelector((state: RootState) => state.titleRoute.listPathName);
    const workingOrganization = useSelector((state: RootState) => state.user?.workingOrganization);

    const itemPathName = listPathName.find(el => el.pathName === Screens.DEPARTMENT_LIST);

    const [model, setModel] = useState<any>({});

    const [dataRequest] = useState<IRequestGetPaged>({
        includeCompany: BooleanInt.False,
        searchText: searchParams.get("searchText"),
        listStatus: searchParams.getAll("listStatus"),
        pageNumber: Number(searchParams.get("pageNumber") || 1),
        pageSize: Number(searchParams.get("pageSize") || Constants.ROW_PER_PAGE),
        totalCount: itemPathName?.totalCount,
    } as IRequestGetPaged);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(idDetail)) {
            handleChangeMode(Mode.Create);
        } else {
            let mode = (pramsMode || Mode.Update);
            handleChangeMode(mode);
        }
    }, [idDetail, pramsMode, workingOrganization]);

    const handleGoBack = () => {
        const itemP = listPathName.find(el => el.pathName === Screens.DEPARTMENT_LIST);
        navigate(Screens.DEPARTMENT_LIST + (itemP ? itemP.query : ""));
    }

    const handleChangeMode = (value: Mode) => {
        let title: string = "";
        let route = [{ title: Strings.DEPARTMENT.TITLE_MENU, route: Screens.DEPARTMENT_LIST }];

        if (value === Mode.Create) {
            title = Strings.DEPARTMENT.TITLE_CREATE_VIEW;
            route = [
                { title: Strings.DEPARTMENT.TITLE_MENU, route: Screens.DEPARTMENT_LIST },
                { title: Strings.COMMON.ADD_NEW, route: "" }
            ];
        }
        if (value === Mode.Update) {
            title = Strings.DEPARTMENT.TITLE_UPDATE_VIEW;
            route = [
                { title: Strings.DEPARTMENT.TITLE_MENU, route: Screens.DEPARTMENT_LIST },
                { title: Strings.COMMON.UPDATE, route: "" }
            ];
        }
        if (value === Mode.View) {
            title = Strings.DEPARTMENT.TITLE_DETAIL_VIEW;
            route = [
                { title: Strings.DEPARTMENT.TITLE_MENU, route: Screens.DEPARTMENT_LIST },
                { title: Strings.COMMON.VIEW_DETAIL, route: "" }
            ];
        }

        setModel({
            ...model,
            mode: value,
            title: title,
            route: route,
        });

        if (!Helpers.isNullOrEmpty(idDetail)) {
            navigate(Screens.DEPARTMENT_DETAIL + `?id=${idDetail}&mode=${value}`, { replace: true });
        }
    }

    return (
        <DashboardLayout
            isPermission
            allowSettingLayout
            requiredOrganization
            title={modeList ? Strings.ORGANIZATION.TITLE_LIST_VIEW : model.title}
            route={modeList ? [{ title: Strings.ORGANIZATION.TITLE_MENU, route: "" }] : model.route}
        >
            <ModuleGroup
                keyModuleContainer={{
                    list: { pathName: Screens.DEPARTMENT_LIST },
                    detail: { pathName: Screens.DEPARTMENT_DETAIL },
                    create: { pathName: Screens.DEPARTMENT_CREATE },
                }}

                allowActionImport
                importTemplateLink={Constants.IMPORT_GROUP_TEMPLATE_LINK}
                groupCode={{ visible: true, label: Strings.DEPARTMENT.CODE }}

                groupLabel={Strings.COMMON.DEPARTMENT}
                staffLabel={Strings.COMMON.STAFF}

                userRole={{
                    ignoreHierarchy: BooleanInt.True
                }}

                nonHierarchical
                unCheckGeneGroup
                getUserNonHierarchical
                requestGetPaged={dataRequest}
                groupTypeCreate={GroupType.Department}
                onNavigate={(data) => {
                    if (data.id) {
                        navigate(Screens.DEPARTMENT_DETAIL + `?id=${data.id}&mode=${data.mode}`);
                    } else {
                        navigate(Screens.DEPARTMENT_CREATE + `?mode=${data.mode}`);
                    }
                }}
                onGetPaged={({ query, totalCount }) => {
                    dispatch(setListPathName({ pathname: Screens.DEPARTMENT_LIST, query, totalCount }));
                    navigate(Screens.DEPARTMENT_LIST + query, { replace: true });
                }}

                mode={model.mode}
                idDetail={idDetail}
                onGoBack={handleGoBack}
                onChangeMode={(value) => { handleChangeMode(value) }}
            />
        </DashboardLayout>
    );
};

export default DepartmentScreen;
